(function () {
  if (customElements.get('ikara-flash-countdown')) return;

  var SP_OFFSET_MS = 3 * 3600 * 1000; // America/Sao_Paulo = UTC-3 fixo (sem horário de verão desde 2019)

  class IkaraFlashCountdown extends HTMLElement {
    connectedCallback() {
      this.headlineEl = this.querySelector('[data-fc-headline]');
      this.sublineEl = this.querySelector('[data-fc-subline]');
      this.labelEl = this.querySelector('[data-fc-label]');
      this.dd = this.querySelector('[data-fc-dd]');
      this.hh = this.querySelector('[data-fc-hh]');
      this.mm = this.querySelector('[data-fc-mm]');
      this.ss = this.querySelector('[data-fc-ss]');
      this.hideExpired = this.dataset.hideExpired === 'true';
      this.timer = null;

      this.applyCampaign();
      this.tick();
      this.timer = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    // Sem offset explícito na data, Date.parse interpreta na hora LOCAL do
    // visitante → a oferta terminaria em momentos diferentes por fuso.
    // Normaliza para America/Sao_Paulo.
    parseEndDate(value) {
      if (!value) return NaN;
      var s = String(value).trim().replace(' ', 'T');
      if (!/(Z|[+-]\d{2}:?\d{2})$/.test(s)) {
        if (!/T\d/.test(s)) s += 'T23:59:59';
        s += '-03:00';
      }
      return Date.parse(s);
    }

    isWeekendSaoPaulo() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo',
          weekday: 'short',
        }).formatToParts(new Date());
        const day = (parts.find((p) => p.type === 'weekday') || {}).value;
        return day === 'Fri' || day === 'Sat' || day === 'Sun';
      } catch (e) {
        const d = new Date().getDay();
        return d === 5 || d === 6 || d === 0;
      }
    }

    // Fim do domingo corrente (23:59:59) em São Paulo — o modo weekend_auto
    // repete todo fim de semana, então a data não pode ser fixa.
    weekendEndSaoPaulo() {
      var spWall = new Date(Date.now() - SP_OFFSET_MS);
      var day = spWall.getUTCDay(); // 0 = domingo
      var daysToSunday = day === 0 ? 0 : 7 - day;
      var wallEnd = Date.UTC(
        spWall.getUTCFullYear(),
        spWall.getUTCMonth(),
        spWall.getUTCDate() + daysToSunday,
        23,
        59,
        59
      );
      return wallEnd + SP_OFFSET_MS;
    }

    applyCampaign() {
      const mode = this.dataset.mode || 'manual';
      const weekendOverride = this.dataset.weekendOverride === 'true';
      const weekend = this.isWeekendSaoPaulo();

      if (mode === 'weekend_auto' && !weekend) {
        this.hidden = true;
        this.activeEndMs = NaN;
        return;
      }

      this.hidden = false;

      const useWeekend = weekend && (mode === 'weekend_auto' || weekendOverride);

      if (useWeekend) {
        if (mode === 'weekend_auto') {
          this.activeEndMs = this.weekendEndSaoPaulo();
        } else {
          this.activeEndMs = this.parseEndDate(this.dataset.weekendEnd || this.dataset.weekdayEnd);
        }
        this.setText(
          this.dataset.weekendHeadline || this.dataset.weekdayHeadline,
          this.dataset.weekendSubline || this.dataset.weekdaySubline,
          this.dataset.weekendLabel || this.dataset.weekdayLabel
        );
      } else {
        this.activeEndMs = this.parseEndDate(this.dataset.weekdayEnd);
        this.setText(
          this.dataset.weekdayHeadline,
          this.dataset.weekdaySubline,
          this.dataset.weekdayLabel
        );
      }
    }

    setText(headline, subline, label) {
      if (this.headlineEl) this.headlineEl.textContent = headline || '';
      if (this.sublineEl) this.sublineEl.textContent = subline || '';
      if (this.labelEl) this.labelEl.textContent = label || '';
    }

    setDigits(d, h, m, s) {
      if (this.dd) this.dd.textContent = this.pad(d);
      if (this.hh) this.hh.textContent = this.pad(h);
      if (this.mm) this.mm.textContent = this.pad(m);
      if (this.ss) this.ss.textContent = this.pad(s);
    }

    pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    tick() {
      // Reavalia a campanha a cada minuto (virada de dia, troca weekday↔weekend)
      if (!this._lastDayCheck || Date.now() - this._lastDayCheck > 60000) {
        this._lastDayCheck = Date.now();
        this.applyCampaign();
      }

      if (this.hidden || !this.activeEndMs || Number.isNaN(this.activeEndMs)) return;

      let diff = this.activeEndMs - Date.now();
      if (diff <= 0) {
        this.setDigits(0, 0, 0, 0);
        if (this.hideExpired) this.hidden = true;
        // Não limpar o interval: applyCampaign precisa reativar o bloco
        // quando a próxima campanha começar (ex.: próximo fim de semana).
        return;
      }

      let s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400);
      s -= d * 86400;
      const h = Math.floor(s / 3600);
      s -= h * 3600;
      const m = Math.floor(s / 60);
      s -= m * 60;

      this.setDigits(d, h, m, s);
    }
  }

  customElements.define('ikara-flash-countdown', IkaraFlashCountdown);
})();
